import { SubBody2 } from '@flatsy/core/MaterialUi/Typo'
import React, { CSSProperties } from 'react'
import { useStyles } from './Style'
import { IProgress } from './Type'

const Progress: React.FC<IProgress> = ({ size }): React.ReactElement => {
  const classes = useStyles()
  const percent = `${size || 0}%`
  const style: CSSProperties = {
    width: percent,
  }
  return (
    <div className={classes.container}>
      <SubBody2>{percent}</SubBody2>
      <div className={classes.wrapper}>
        <div className={classes.line} style={style} />
      </div>
    </div>
  )
}

export default Progress
